import LOGO from "../assets/images/ecos_Logo_Stuttgart_CMYK.png";
import COUNTRIES from '../assets/data/countries.json'

export default {
  LOGO,
  COUNTRIES: COUNTRIES.data,
}
